import { container } from "assets/jss/material-dashboard-pro-react.js";

const styles = (theme) => ({
  container: {
    ...container,
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "100px",
    },
  },
  cardHover: {
    "&:hover": {
      "& $cardHeaderHover": {
        transform: "translate3d(0, -10px, 0)",
      },
    },
  },
  gridNoPadding: {
    padding: "0 !important",
  },
  cardHeader: {
    padding: "10px",
  },
  cardHeaderHover: {
    transition: "all 300ms cubic-bezier(0.34, 1.61, 0.7, 1)",
  },
  cardTitle: {
    margin: "0",
    marginLeft: ".4rem",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",

    fontSize: "1rem",
    display: "inline",
    textDecoration: "none",
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)",
  },
  item: {
    padding: "0 .3rem",
  },
  cardNoPadding: {
    padding: "0.9375rem  .625rem  .7rem",
  },
  grid: {
    padding: "0 .4rem",
    margin: "0",
    justifyContent: "center",
    width: "100%",
  },
  noPaddingTop: {
    paddingTop: "2.8rem",
  },
  marginCard: {
    marginTop: "1.5rem",
  },
});

export default styles;
